import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import ProgressBar from '../../../../components/Loader/ProgressBar';

function PreviewGenerationStatus({ progress = 0, failed = false, onRetry = null, className = '' }) {
    if(failed) {
        return (
            <div className={`preview-generation-global ${className}`.trim()}>
                <div className="preview-generation-status" role="alert">
                    <p className="preview-generation-status__text">
                        <FormattedMessage id="conversationGenerationFailed" defaultMessage="Something interrupted the layout of your book." />
                    </p>
                    <p className="preview-generation-status__hint">
                        <FormattedMessage id="conversationGenerationFailedHint" defaultMessage="Your messages are safe. Give it another try, and if it happens again, write to us and we'll look into it with you." />
                    </p>
                    <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">
                        <Button tag="button" className="btn-atelier-primary" onClick={onRetry}>
                            <FormattedMessage id="conversationGenerationRetry" defaultMessage="Try again" />
                        </Button>
                        <Button color="link" tag={Link} to="/contact">
                            <FormattedMessage id="contactButton" defaultMessage="Contact us" />
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
    const displayPercent = Math.min(100, Math.max(0, Math.round(progress)));
    return (
        <div className={`preview-generation-global ${className}`.trim()}>
            <div className="preview-generation-status" role="status" aria-live="polite" aria-busy="true">
                <p className="preview-generation-status__text">
                    <FormattedMessage id="conversationGenerationAlert" defaultMessage="Your conversation is being generated..." />
                </p>
                <p className="preview-generation-status__percent" aria-hidden="true">
                    {displayPercent}%
                </p>
                <ProgressBar percent={progress} hideValue />
                <p className="preview-generation-status__hint">
                    <FormattedMessage id="conversationGenerationAlert2" defaultMessage="Please stay on the page to speed up the generation!" />
                </p>
            </div>
        </div>
    );
}

PreviewGenerationStatus.propTypes = {
    progress: PropTypes.number,
    failed: PropTypes.bool,
    onRetry: PropTypes.func,
    className: PropTypes.string,
};

export default PreviewGenerationStatus;
